import ContactUs from '../components/ContactUs'

export default function Contact() {
    return (
        <div className='contact-page'>
            <ContactUs />
        </div>
    )
}
